const getters = {
  router: state => state.user.router,
  user: state => state.user.user
  
}

export default getters